import React from 'react';
import './AppFooter.scss';

export const AppFooter = (props) => {

    return (
        <div className="layout-footer">
            <span className="col py-1 m-0" style={{ backgroundColor: '#0C623B' }}></span>
            <span className="col py-1 m-0" style={{ backgroundColor: '#FEC929' }}></span>
            <span className="col py-1 m-0" style={{ backgroundColor: '#ED242C' }}></span>
        </div>
    );
}
